export default __webpack_public_path__ + "static/sc-lobbyst-6cad9759f6b1372b32e1617c7a888fde.webp";